import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import CookieConsent from "@/components/site/CookieConsent";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import ServicePage from "@/pages/ServicePage";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/ai-wine-audit" element={<ServicePage />} />
            <Route path="/revenue-starter" element={<ServicePage />} />
            <Route path="/growth-system" element={<ServicePage />} />
            <Route path="/export-scale" element={<ServicePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookie" element={<CookiePolicy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
